<template>
  <div id="app" v-if="title != ''" v-title :data-title="title"  >
    <router-view/>
  </div>
</template>

<script>
import { mapActions,mapMutations } from "vuex";
export default {
  name: 'App',
  data(){
    return {
      title:'',
    }
  },
  created(){
    
    this.getWebconfigInfo().then(res=>{
          this.title = res.title
          this.setWebInfo(res)
          setTimeout(function(){
            this.title = res.title
            if(res.style){
              require('./commonStyleInit.js');
            }
          },100)
      }).catch(err=>{
        console.log(err)
      })
      
  },
  mounted(){
    var bp = document.createElement('script');
    var curProtocol = window.location.protocol.split(':')[0];
    if (curProtocol === 'https') {
        bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
    }
    else {
        // bp.src = 'http://push.zhanzhang.baidu.com/push.js';
        bp.src = '//zz.bdstatic.com/linksubmit/push.js';
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(bp, s);
  },
  methods:{
      ...mapMutations(['setWebInfo']),   
      ...mapActions(['getWebconfigInfo'])        
  }
}
</script>

<style>
    body {
        margin: 0 !important;
    }
   .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: ".";
        clear: both;
        height: 0;
    }
    html,body {
      font-family: "MicrosoftYaHei";
    }
    
</style>



// WEBPACK FOOTER //
// src/App.vue